import toDate from '../toDate/index';
import constructFrom from '../constructFrom/index';
/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param date - the original date
 * @returns the end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */
export default function endOfYear(dirtyDate) {
    const cleanDate = toDate(dirtyDate);
    const date = constructFrom(dirtyDate, 0);
    date.setFullYear(cleanDate.getFullYear() + 1, 0, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}
